function getPayChannel(channel: string) {
  if (channel === 'AliPay') return '支付宝';
  if (channel === 'WxPay') return '微信支付';
  return '';
}

export default getPayChannel;
